import request from '@/utils/request';
import { dataModelReportsEndpoint, dictionaryReportsEndpoint } from '@/constants/urls';

const dataModelReports = (code) => request({
  method: 'GET',
  url: dataModelReportsEndpoint(code),
});

const dataModelReportDownload = (code, reportId) => request({
  method: 'GET',
  url: dataModelReportsEndpoint(code, reportId),
});

const dictionaryReports = (code, reportType) => request({
  method: 'GET',
  url: dictionaryReportsEndpoint(code, reportType),
});

const dictionaryReportDownload = (code, reportType, reportId) => request({
  method: 'GET',
  url: dictionaryReportsEndpoint(code, reportType, reportId),
});

const DatasetReportsService = {
  dataModelReports,
  dataModelReportDownload,
  dictionaryReports,
  dictionaryReportDownload,
};

export default DatasetReportsService;
